import React, { useState } from 'react'
import { Modal, Form, Input, message, notification } from 'antd'
import strings from '../../utils/Localization'
import useApi from '../../hooks/useApi'
import { useNavigate } from 'react-router-dom'

export default function SubeEkleModal({ visible = false, handleCancel }) {
  const [form] = Form.useForm()
  const [fetchLoading, setFetchLoading] = useState(false)
  const navigate= useNavigate()
  const api = useApi()
  const { subeEkle: localization } = strings

  const onFinish = async (values) => {
    try {
      const { subeAd } = values

      setFetchLoading(true)

      const response = await api.post('/sube', {
        SubeAd: subeAd,
      })

      if (response.status === 200) {
        form.resetFields()
        notification['success']({
          message: strings.mesaj.basarliBaslik,
          description: strings.mesaj.islemBasarili,
        })
        handleCancel()
        navigate(0)
      }
    } catch (error) {
      message.error(error.message)
    } finally {
      setFetchLoading(false)
    }
  }

  return (
    <Modal
      title={localization.baslik}
      visible={visible}
      onCancel={handleCancel}
      handleCancel={handleCancel}
      okButtonProps={{
        htmlType: 'submit',
        form: 'subeEkleForm',
        loading: fetchLoading,
      }}
    >
      <Form form={form} name="subeEkleForm" layout="vertical" onFinish={onFinish}>
        <Form.Item name="subeAd" label={localization.subeAdi} rules={[{ required: true }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}
